import styled from "styled-components";

import hands_dislike_icon from '../../../../assets/hands_dislike.svg';
import hands_like_icon from '../../../../assets/hands_like.svg';
import { IPhotoGeneratorFormValues, IRateGeneratedPhotoFormValues, LikeStatusEnum } from '../../form';

interface IViewGeneratedPhotoStepProps {
  generatedImage: string;
  onFeedback: (values: IRateGeneratedPhotoFormValues) => Promise<void>;
  values: IPhotoGeneratorFormValues;
  setFieldValue: (field: string, value: string | LikeStatusEnum | null) => void;
}

const ViewGeneratedPhotoStep: React.FC<IViewGeneratedPhotoStepProps> = (props) => {
  const { generatedImage, onFeedback, values, setFieldValue } = props;

  const handleLike = () => {
    setFieldValue('type', values.type === LikeStatusEnum.Like ? null : LikeStatusEnum.Like);
  };

  const handleDislike = () => {
    setFieldValue('type', values.type === LikeStatusEnum.Dislike ? null : LikeStatusEnum.Dislike);
  };


  return (
    <>
      <GeneratedImage src={generatedImage} alt="Generated" />
      <FeedbackSection>
        <FeedbackTitle>Help us improve by ranking this image</FeedbackTitle>
        <FeedbackFormWrapper>
          <CommentBox
            name="comment"
            placeholder="Comment"
            value={values.comment}
            onChange={(e) => setFieldValue('comment', e.target.value)}
          />
          <ButtonGroup>
            <DislikeButton
              isActive={values.type === LikeStatusEnum.Dislike}
              onClick={handleDislike}
              type="button"
            >
              <LikesImg src={hands_dislike_icon} alt="Dislike" />
            </DislikeButton>
            <LikeButton
              isActive={values.type === LikeStatusEnum.Like}
              onClick={handleLike}
              type="button"
            >
              <LikesImg src={hands_like_icon} alt="Like" />
            </LikeButton>
          </ButtonGroup>
        </FeedbackFormWrapper>
        <CreateNewPhotoButton onClick={() => onFeedback({ type: values.type || null, comment: values.comment as string })}>
          Add comment
        </CreateNewPhotoButton>
      </FeedbackSection>
    </>
  );
};


export default ViewGeneratedPhotoStep;

const GeneratedImage = styled.img`
  width: 100%;
  border-radius: 12px;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    max-width: 320px;
    height: 100%;
    object-fit: cover;
    margin: 0 auto 32px;
  }
`;

const FeedbackSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const FeedbackTitle = styled.h3`
  font-family: Raleway;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  text-align: left;
  align-self: flex-start;

  @media (max-width: 720px) {
    font-size: 16px;
  }
`;

const LikesImg = styled.img`
  transform: translate(-32%, -52%);
  position: absolute;
`;

const FeedbackFormWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 720px) {
    margin-bottom: 16px;
  }
`;

const FeedbackButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  height: 48px;
  width: 48px;
  border-radius: 64px;
  background: var(--Base-Color_bg_primary, #100D0B);

  &.like {
    background: #4caf50;
    color: white;
  }

  &.dislike {
    background: #f44336;
    color: white;
  }
`;

const LikeButton = styled(FeedbackButton) <{ isActive: boolean }>`
  background: ${({ isActive }) => (isActive ? '#FF7E55' : '#100D0B')};
`;

const DislikeButton = styled(FeedbackButton) <{ isActive: boolean }>`
  background: ${({ isActive }) => (isActive ? '#FA1E1E' : '#100D0B')};
`;

const CommentBox = styled.textarea`
  background-color: rgba(19, 19, 19, 1);
  border: 1px solid transparent;
  border-radius: 8px;
  color: white;
  max-height: 50px;
  font-size: 16px;
  line-height: 18px;
  outline: none;
  font-family: Nunito Sans;
  flex: 1;
  padding: 14px;
  resize: none;

  :focus {
    border-color: #ff7e55;
    box-shadow: none;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const CreateNewPhotoButton = styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 32px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid rgb(255, 126, 85);
`; 
